import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ReportsIndexRoute extends Route {
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('model-manager/report-schedule-settings')
	declare mmReportScheduleSettingsService: Service.ModelManager.ReportScheduleSettings;
	@service('model-manager/reminders') declare mmRemindersService: Service.ModelManager.Reminders;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-reports';

		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmReportsService.requestReports());

		void this.mmRemindersService.requestReminders();
		void this.mmReportScheduleSettingsService.requestReportSchedules();

		return Promise.all(promises);
	}
}
